import React from 'react';
import { useTheme } from 'contexts/theme';
import styles from './footer.module.sass';

export default function Footer() {
  const { dark } = useTheme();
  const currentYear = new Date().getFullYear();
  return (
    <div className={dark ? styles['footer-dark'] : styles.footer}>
      {`Copyright @ ${currentYear} linedrive. All rights received`}
    </div>
  );
}
